module.exports = __webpack_public_path__ + "img/arbolabc.4c2e9376.jpg";